import { render } from "./logPage.vue?vue&type=template&id=10ca15cb&scoped=true"
import script from "./logPage.vue?vue&type=script&lang=js"
export * from "./logPage.vue?vue&type=script&lang=js"

import "./logPage.vue?vue&type=style&index=0&id=10ca15cb&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ca15cb"]])

export default __exports__